import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { USER_CLICK, USER_CLOSED_PAUSEROLL, USER_FULLSCREEN } from '../../../../types';
import { DIALOG_LAYER } from '../../../common/constants';
import { useFadeInComponent, usePlayerContext, useStyles } from '../../../common/hooks';
import { connect, withBreakPoints } from '../../hoc';
import { MAIN_GRADIENT_AD } from '../../theme/colors';
import { Button, Label } from '../common';
import { EXP_CONTROL_ICON_STYLES } from '../controls/exp/styles';
import PauserollResume from '../controls/pauserollresume';
import {
  ADPAUSE_SCREEN,
  ADPAUSE_SCREEN_AD_LABEL,
  ADPAUSE_SCREEN_BACKGROUND,
  ADPAUSE_SCREEN_CLOSE_BUTTON_WRAPPER,
  ADPAUSE_SCREEN_CONTROLS_WRAPPER,
  ADPAUSE_SCREEN_FULLSCREEN_BUTTON_WRAPPER,
  ADPAUSE_SCREEN_RESUME_BUTTON_WRAPPER
} from './styles';

function AdPauseOverlay({ pauseRollIsDisplayable, pauseRollContent, isFullscreen, isTv }) {
  const player = usePlayerContext();
  const setStyles = useStyles();
  const { size: iconSize } = setStyles(EXP_CONTROL_ICON_STYLES);

  const [shouldRender, visible] = useFadeInComponent(pauseRollIsDisplayable);

  const resumeButtonRef = useRef();
  useEffect(() => {
    if (visible) resumeButtonRef.current.children[0].focus();
  }, [pauseRollContent, pauseRollIsDisplayable, shouldRender, visible]);

  if (!shouldRender) return null;

  return (
    <div
      className="ftv-in-customizable adpause"
      style={{
        zIndex: DIALOG_LAYER,
        ...ADPAUSE_SCREEN,
        width: visible ? '100%' : '0px',
        height: visible ? '100%' : '0px',
        opacity: Number(visible),
        backgroundColor: visible ? 'black' : 'transparent',
        transition: visible
          ? 'background-color 0.5s ease-in, opacity 0.5s ease-in'
          : ''
      }}
    >
      <div
        style={{
          ...ADPAUSE_SCREEN_BACKGROUND,
          opacity: Number(visible),
          transition: visible
            ? 'background-image 2s ease-in, opacity 2s ease-in'
            : '',
          backgroundImage: pauseRollContent?.image ? `url("${pauseRollContent.image}")` : 'none',
          cursor: 'pointer'
        }}
        role="presentation"
      >
        <div style={{ backgroundImage: MAIN_GRADIENT_AD, width: '100%' }}>
          <div style={ADPAUSE_SCREEN_CONTROLS_WRAPPER}>
            <Label
              message="Publicité"
              style={setStyles(ADPAUSE_SCREEN_AD_LABEL)}
            />

            <div style={setStyles(ADPAUSE_SCREEN_CLOSE_BUTTON_WRAPPER)}>
              <Button
                hidden={isTv}
                type="icon"
                openingMode="click"
                label="Fermer la publicité"
                ariaLabel="Fermer la publicité"
                forceLabel
                disableFocus={!visible}
                last
                zone="top"
                icon="close"
                name="btn-close-adpause"
                size={iconSize}
                ariaHidden={false}
                onClick={() => {
                  player.userEvents$.next({ action: USER_CLOSED_PAUSEROLL });
                }}
              />
            </div>

            <div style={setStyles(ADPAUSE_SCREEN_RESUME_BUTTON_WRAPPER)}>
              <PauserollResume innerRef={resumeButtonRef} disableFocus={!visible} />
            </div>

            <div style={setStyles(ADPAUSE_SCREEN_FULLSCREEN_BUTTON_WRAPPER)}>
              <Button
                hidden={isTv}
                label={`${isFullscreen ? 'Quitter le plein écran' : 'Plein écran'} (f)`}
                ariaLabel={isFullscreen ? 'Quitter le mode plein écran' : 'Plein écran'}
                ariaHidden="false"
                onClick={() => {
                  player.userEvents$.next({
                    action: USER_FULLSCREEN,
                    value: !isFullscreen,
                    source: USER_CLICK
                  });
                  player.fullscreen(!isFullscreen);
                }}
                last
                xs
                name="btn-fullscreen-adpause"
                icon={isFullscreen ? 'fullscreen-on' : 'fullscreen-off'}
                disableFocus={!visible}
                type="icon"
                size={iconSize}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const selector = (state) => {
  const {
    ad: {
      pauseRollIsDisplayable,
      pauseRollContent
    },
    ui: { isFullscreen },
    media: { isTv }
  } = state;
  return {
    pauseRollIsDisplayable,
    pauseRollContent,
    isFullscreen,
    isTv
  };
};

export default withBreakPoints(connect(selector)(AdPauseOverlay));
